import { PartnerType } from "@/app/utils/partners.enum";

export enum JourneyStatusEnum {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export enum JourneyStepStatusEnum {
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  SKIPPED = "SKIPPED",
  PENDING = "PENDING",
}

export type JourneyListItem = {
  _id: string;
  journeyId: string;
  product: PartnerType;
  status: JourneyStatusEnum;
  variant?: string;
  currentStep: string;
  currentStepLabel: string;
  currentStepOrder: number;
  furthestStepOrder: number;
  totalSteps: number;
  stale: boolean;
  seller?: { _id: string; name: string; cpf: string };
  customer?: { _id: string; name: string; cpf: string };
  cpf?: string;
  startedAt: string;
  lastStepAt: string;
  finishedAt?: string;
  durationMs?: number;
  stepsCount: number;
  totalAttempts: number;
};

export type GetJourneysParams = {
  product?: PartnerType[];
  status?: JourneyStatusEnum[];
  sellerIds?: string[];
  teamIds?: string[];
  currentStep?: string;
  from?: string;
  to?: string;
  search?: string;
  onlyStale?: boolean;
  skip?: number;
  limit?: number;
  sort?: string;
  order?: "1" | "-1";
};

export type GetJourneysResponse = {
  journeys: JourneyListItem[];
  pagination: {
    skip: number;
    limit: number;
    total: number;
    sort: string;
    order: string;
  };
};

export type JourneyTimelineStep = {
  key: string;
  label: string;
  order: number;
  optional: boolean;
  status: JourneyStepStatusEnum;
  attempts: number;
  firstAttemptAt: string | null;
  lastAttemptAt: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  durationMs: number | null;
  error: { code?: string; message?: string } | null;
  meta: {
    request?: Record<string, unknown>;
    response?: Record<string, unknown>;
    attemptsRange?: Record<string, { min: number; max: number }>;
    truncated?: boolean;
  } | null;
};

export type JourneyDetails = JourneyListItem & {
  timeline: JourneyTimelineStep[];
};

export type FunnelStep = {
  key: string;
  label: string;
  order: number;
  optional: boolean;
  entered: number;
  advanced: number;
  completed: number;
  dropped: number;
  pending: number;
  errors: number;
  dropRate: number;
  errorRate: number;
  avgDurationMs: number | null;
  totalAttempts: number;
  topErrors: { message: string; count: number }[];
};

export type GetFunnelParams = {
  product: PartnerType;
  sellerIds?: string[];
  teamIds?: string[];
  from?: string;
  to?: string;
  search?: string;
};

export type GetFunnelResponse = {
  product: PartnerType;
  abandonTimeoutMinutes: number;
  totals: {
    started: number;
    completed: number;
    dropped: number;
    pending: number;
    conversionRate: number;
  };
  steps: FunnelStep[];
};
